import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Offer } from './components/Offer';
export function App() {
  return <main className="min-h-screen bg-brand-cream font-sans text-brand-brown overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Solution data-id="element-3" />
      <Offer data-id="element-4" />
    </main>;
}